import { useCallback } from 'react';

/**
 * Persistent storage wrapper for read/write operations.
 *
 * Planning on having this switch between localStorage on web
 * and @capacitor/storage for native apps.
 */
export function usePersistentStorage() {
  const set = useCallback((key: string, value: string) => {
    try {
      window.localStorage.setItem(key, value);
    } catch {
      console.warn('Unable to set item in storage');
    }
  }, []);
  const get = useCallback((key: string) => {
    let value: string | null = null;
    try {
      value = window.localStorage.getItem(key);
    } catch {
      console.warn('Unable to get item from storage');
    } finally {
      return value;
    }
  }, []);

  const flush = useCallback((key: string) => {
    try {
      window.localStorage.removeItem(key);
    } catch {
      // silently fail
    }
  }, []);
  return { set, get, flush };
}
